/* eslint-disable react/jsx-handler-names */
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/soyuz/client';

import NoSSR from 'react-no-ssr';

import Button from '../../Button';
import LanguageSwitcher from '../../LanguageSwitcher';

import HeaderLink from '../HeaderLink';
import HeaderItem from '../HeaderItem';
import HeaderItems from '../HeaderItems';

import themeShape, { DARK_THEME } from '../shapes/theme.shape';
import LoginIconButton from '../../LoginButtonComponent/LoginIconButton';

const HeaderNavSimplified = ({ color = DARK_THEME, showLogin }) => {
  return (
    <HeaderItems>
      <HeaderItem>
        <Button
          color="white"
          className="ga-home-publish-your-property-top header-button"
          href={getPagePath('externals.landlord-landing')}
          size="small"
        >
          {trans('landingpage.button.landlord')}
        </Button>
      </HeaderItem>
      {showLogin ? (
        <NoSSR>
          <HeaderItem>
            <LoginIconButton />
          </HeaderItem>
        </NoSSR>
      ) : null}
      <HeaderItem>
        <HeaderLink color={color}>
          <LanguageSwitcher theme={color} abbreviated />
        </HeaderLink>
      </HeaderItem>
    </HeaderItems>
  );
};

HeaderNavSimplified.propTypes = {
  color: themeShape,
  showLogin: PropTypes.bool.isRequired
};

export default HeaderNavSimplified;
